/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], function () {
	// Temporary array of dashboard feature specs. This can be used to quickly test a dashboard feature without adding to the perspective collection
	// Example:
	// {
	// 	"containerId": "com.ibm.bi.dashboard.core-features",
	// 	"name": "myFeature",
	// 	"id": "com.ibm.bi.dashboard.core-features.myFeature",
	// 	"class": "dashboard-core/features/dashboard/actions/content/deleteAction/api/impl/DeleteAction"
	// }
	return [{
		'containerId': 'com.ibm.bi.dashboard.core-features',
		'name': 'segment',
		'id': 'com.ibm.bi.dashboard.core-features.segment',
		'class': 'dashboard-core/js/features/dashboard/segment/SegmentFeature'
	},
	{
		'containerId': 'com.ibm.bi.dashboard.core-features',
		'name': 'CoachMark',
		'id': 'com.ibm.bi.dashboard.core-features.coachMark',
		'class': 'dashboard-core/js/features/dashboard/coachMark/api/impl/CoachMark'
	}];
});
